import React from 'react';
import PropTypes from 'prop-types';

function IconAddedCart({ color = '#EF476F', size = 16, className }) {
  return (
    <svg id={'icon-added-cart'} width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99976 2H4.52614L6.79988 12.4424C6.87862 12.8285 7.09029 13.1749 7.39803 13.421C7.70577 13.6672 8.09011 13.7977 8.48413 13.7898H14.9685C15.3625 13.7977 15.7469 13.6672 16.0546 13.421C16.3624 13.1749 16.574 12.8285 16.6528 12.4424L18.0002 5.36851H5.87354M8.31406 18C8.77916 18 9.15619 17.623 9.15619 17.1579C9.15619 16.6928 8.77916 16.3157 8.31406 16.3157C7.84897 16.3157 7.47194 16.6928 7.47194 17.1579C7.47194 17.623 7.84897 18 8.31406 18ZM15.0494 18C15.5145 18 15.8916 17.623 15.8916 17.1579C15.8916 16.6928 15.5145 16.3157 15.0494 16.3157C14.5843 16.3157 14.2073 16.6928 14.2073 17.1579C14.2073 17.623 14.5843 18 15.0494 18Z" stroke={color} fill={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )

  // return (
  //   <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clipPath="url(#clip0_6719_12504)">
  //       <path d="M6.665 12.2451C5.885 12.2451 5.245 12.8751 5.245 13.6651C5.245 14.4551 5.885 15.0851 6.665 15.0851C7.445 15.0851 8.085 14.4451 8.085 13.6651C8.085 12.8851 7.445 12.2451 6.665 12.2451Z" fill={color}/>
  //       <path d="M11.9951 12.2451C11.2151 12.2451 10.5751 12.8751 10.5751 13.6651C10.5751 14.4551 11.2051 15.0851 11.9951 15.0851C12.7851 15.0851 13.4151 14.4451 13.4151 13.6651C13.4151 12.8851 12.7751 12.2451 11.9951 12.2451Z" fill={color}/>
  //       <path d="M14.905 3.85504C14.765 3.68504 14.555 3.58504 14.325 3.58504H4.85504L4.40504 1.50504C4.32504 1.16504 4.02504 0.915039 3.67504 0.915039H1.66504C1.25504 0.915039 0.915039 1.25504 0.915039 1.66504C0.915039 2.07504 1.25504 2.41504 1.66504 2.41504H3.06504L4.73504 10.085C4.83504 10.565 5.09504 10.995 5.47504 11.295C5.84504 11.595 6.30504 11.755 6.76504 11.755H11.925C12.385 11.755 12.885 11.605 13.265 11.295C13.645 10.995 13.905 10.565 14.005 10.075L15.075 4.47504C15.115 4.25504 15.055 4.02504 14.915 3.85504H14.905Z" fill={color}/>
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_6719_12504">
  //         <rect width="14.17" height="14.17" fill="white" transform="translate(0.915039 0.915039)"/>
  //       </clipPath>
  //     </defs>
  //   </svg>
  // )
}

IconAddedCart.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconAddedCart;
